export default "__VITE_ASSET__BbthvY6e__"